// extracted by mini-css-extract-plugin
export default {"page__title":"styles_page__title__CVte7","section-head__container--top":"styles_section-head__container--top__i638P","description__text":"styles_description__text__+Ijcy"};